export default __webpack_public_path__ + "static/media/izipaylogo.8e6aa055.png";